/* eslint-disable @typescript-eslint/no-unused-vars */

import PropTypes from 'prop-types';
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext, useEffect, useState } from 'react';
import { $iq, $msg, $pres, Strophe, mam, query } from 'strophe.js';
import { getNewMessages, sendNewMessage, readNewMessages } from '@webapps/business';

import { useAuth, useLocalStorage, useMutation } from '../..';

const variables = {
  jabberDomain: process.env.NX_REACT_APP_JABBER_SERVER || '',
  boshServer: process.env.NX_REACT_APP_WSS_SERVER || '',
};

const StropheContext = createContext();

let connection = new Strophe.Connection(variables.jabberDomain);

// DEBUG:

// connection.xmlInput = function (data) {
//   console.log('RECV:', data);
// };

// connection.xmlOutput = function (data) {
//   console.log('SENT:', data);
// };


const StropheProvider = ({ children }) => {
  // const getJabberUserId = (bearer) => `${bearer}@${variables.jabberDomain}`;
  const { email, idUser, userAlias } = useAuth();

  useEffect(() => {
    if (connection.connected === false) {
      if (idUser && userAlias) {
        connectStrophe({
          jabid: `${userAlias}@linkpick.fr`,
          pass: idUser,
        });
      }
    }
  }, [connection]);

  const [connect, setConnect] = useState(false)
  const [jabberUser, setJabberUser] = useState('');
  const [actions, setActions] = useState('');
  const [messagesReceived, setMessagesReceived] = useState([]);
  const [archive, setArchive] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [endIQ, setEndIQ] = useState(false);

  const wssGenerator = (url) => {
    if (
      ['wss://', 'ws://', 'http://', 'https://'].some((protocol) =>
        url.includes(protocol)
      )
    ) {
      return url;
    }
    return `wss://${url}`;
  };

  useEffect(() => {
    if (!connect) {
      if (idUser && userAlias) {
        connectStrophe({
          jabid: `${userAlias}@linkpick.fr`,
          pass: idUser,
        });
      }
    }
  }, [connect]);

  const {
    isSuccess: isGetNewMessagesSuccess,
    data: dataGetNewMessages,
    mutate: mutateGetNewMessages,
  } = useMutation(getNewMessages);

  const {
    mutate: mutateSendNewMessage,
  } = useMutation(sendNewMessage);

  const {
    isSuccess: isReadNewMessagesSuccess,
    mutate: mutateReadNewMessages,
  } = useMutation(readNewMessages);


  useEffect(() => {
    mutateGetNewMessages({ to: userAlias })
  }, [userAlias]);

  useEffect(() => {
    if (isGetNewMessagesSuccess) {
      setMessagesReceived(dataGetNewMessages);
    }
  }, [isGetNewMessagesSuccess]);

  useEffect(() => {
    if (isReadNewMessagesSuccess) {
      mutateGetNewMessages({ to: userAlias })
    }
  }, [isReadNewMessagesSuccess]);

  const connectStrophe = ({ jabid, pass }) => {
    setConnect(false);
    connection.connect(jabid, pass, connectHandler);
    setJabberUser(jabid);
  };

  const connectionSend = (data) => {
    if (connection && connection.connected) {
      connection.send(data);
    } else {
      setConnect(false);
    }
  };

  // const connection = new Strophe.Connection(wssGenerator(variables.boshServer));

  const presenceHandler = (presence) => {
    const from = presence.getAttribute('from');
    const pType = presence.getAttribute('type');
    if (pType === 'subscribe') {
      connectionSend(
        $pres({
          to: from,
          type: 'subscribed',
        })
      );

      connectionSend(
        $pres({
          to: from,
          type: 'subscribe',
        })
      );
    }
    let show = '';
    let status = '';
    Strophe.forEachChild(presence, 'show', (elem) => {
      show = elem.textContent;
    });
    Strophe.forEachChild(presence, 'status', (elem) => {
      status = elem.textContent;
    });

    //
    if (show || status) {
      setActions(`[presence] ${from}:${status} ${show}`);
    }
  };

  const connectHandler = (cond) => {
    try {
      if (cond === Strophe.Status.CONNECTED) {
        connectionSend($pres());
        connection.addHandler(presenceHandler, null, 'presence', null);
        connection.addHandler(messageHandler, null, 'message', 'chat');
        connection.addHandler(pingHandler, 'urn:xmpp:ping', 'iq', 'get');
        connection.addHandler(allMessagesHandler, 'urn:xmpp:mam:2', 'message', null);
        connection.addHandler(endIQHandler, 'urn:xmpp:mam:2', 'iq', 'result');
        connection.addHandler(handleRoster, 'jabber:client', 'iq', 'result');
        setConnect(true);
      } 
      else if (cond === Strophe.Status.DISCONNECTING) {
        setTimeout(() => {
        if (idUser && userAlias) {
          connectStrophe({ jabid: jabberUser, pass: idUser });
        }
        setConnect(false);
        }, 10000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRoster = (roster) => {
    const list = roster.querySelectorAll('item');
    // list.forEach((el) => {
    //   const jid = el.getAttribute('jid');
    //   setContacts((current) => [...current, jid]);
    // });
    // eslint-disable-next-line no-plusplus
    for (let i = 0, n = list.length; i < n; ++i) {
      const jid = list[i].getAttribute('jid');
      if (jid && jid !== 'null@linkpick.fr' && jid !== 'null') {
        setContacts((current) => [...current, jid]);
      }
    }
    return true;
  };

  const allMessagesHandler = (message) => {
    const id = message.querySelector('result').getAttribute('id');
    const fwd = message.querySelector('forwarded');
    const d = fwd.querySelector('delay').getAttribute('stamp');
    const msg = fwd.querySelector('message');
    const msgData = {
      id,
      with: Strophe.getBareJidFromJid(msg.getAttribute('to')),
      timestamp: new Date(d),
      timestamp_orig: d,
      from: Strophe.getBareJidFromJid(msg.getAttribute('from')),
      to: Strophe.getBareJidFromJid(msg.getAttribute('to')),
      type: msg.getAttribute('type'),
      body: msg.getAttribute('body'),
      message: Strophe.xmlunescape(
        Strophe.getText(msg.getElementsByTagName('body')[0]) || ''
      ),
    };
    setArchive((current) => [...current, msgData]);
    return true;
  };

  const endIQHandler = (iq) => {
    setEndIQ(true);
    // Indicate that this handler should be called repeatedly
    return true;
  };

  const setPresence = (value) => {
    const pres = $pres().c('show').t('away').up().c('status').t(value);
    connectionSend(pres);
  };

  const getAllMessage = () => {
    setArchive([]);
    const iq = $iq({ type: 'set', id: 'getMessage' }).c('query', {
      xmlns: 'urn:xmpp:mam:2',
    });
    connectionSend(iq);
  };

  const getRoster = ({ from }) => {
    setContacts([]);
    const iq = $iq({ type: 'get', from, id: 'getContact' }).c('query', {
      xmlns: 'jabber:iq:roster',
    });
    connectionSend(iq);
  };

  const getAllMessageWithQuery = ({ withUser }) => {
    setArchive([]);
    const iq = $iq({ type: 'set', id: 'getMessageWith' })
      .c('query', {
        xmlns: 'urn:xmpp:mam:2',
      })
      .c('x', { xmlns: 'jabber:x:data', type: 'submit' })
      .c('field', { var: 'FORM_TYPE', type: 'hidden' })
      .c('value')
      .t('urn:xmpp:mam:2')
      .up()
      .up()
      .c('field', { var: 'with' })
      .c('value')
      .t(withUser);
    withUser = withUser?.split('@')[0];
    mutateReadNewMessages({ to: userAlias, from: withUser })
    connectionSend(iq);
  };

  const messageHandler = (message) => {
    getAllMessage();
    const from = message.getAttribute('from');
    let body = '';
    Strophe.forEachChild(message, 'body', (elem) => {
      body = elem.textContent;
    });
    if (body) {
      setTimeout(() => {
        mutateGetNewMessages({ to: userAlias })
      }, 1000);
      // setArchive((current) => [...current, { from, content: body }]);
    }
    return true;
  };

  const sendMessage = ({ msg, to }) => {
    if (!contacts.includes(to)) {
      addNewContact({ newContact: to });
    }
    const message = $msg({ to, type: 'chat' }).c('body').t(msg);
    connectionSend(message);
    to = to?.split('@')[0];
    mutateSendNewMessage({ to,from: userAlias, message: msg });
  };

  const pingHandler = (ping) => {
    const pingId = ping.getAttribute('id');
    const from = ping.getAttribute('from');
    const to = ping.getAttribute('to');
    const pong = $iq({ type: 'result', to: from, id: pingId, from: to });
    connectionSend(pong);
    return true;
  };

  const addNewContact = ({ newContact }) => {
    const iq = $iq({ type: 'set' })
      .c('query', { xmlns: 'jabber:iq:roster' })
      .c('item', { jid: newContact });
    connection.sendIQ(iq);
    const subscribe = $pres({ to: newContact, type: 'subscribe' });
    connectionSend(subscribe);
  };

  const disconnect = (disconnectingReason) => {
    connection.disconnect(disconnectingReason);
    setConnect(false);
  };

  return (
    <StropheContext.Provider
      value={{
        connectStrophe,
        jabberUser,
        setPresence,
        actions,
        messagesReceived,
        setMessagesReceived,
        sendMessage,
        getAllMessage,
        getAllMessageWithQuery,
        disconnect,
        archive,
        setArchive,
        endIQ,
        connect,
        getRoster,
        contacts,
        setConnect,
      }}
    >
      {children}
    </StropheContext.Provider>
  );
};

StropheProvider.propTypes = {
  children: PropTypes.node,
};

export const useStrophe = () => {
  const {
    actions,
    archive,
    connect,
    connectStrophe,
    contacts,
    disconnect,
    endIQ,
    getAllMessage,
    getAllMessageWithQuery,
    getRoster,
    jabberUser,
    messagesReceived,
    setMessagesReceived,
    sendMessage,
    setArchive,
    setConnect,
    setPresence,
  } = useContext(StropheContext);
  return {
    connectStrophe,
    jabberUser,
    setPresence,
    actions,
    messagesReceived,
    setMessagesReceived,
    archive,
    setArchive,
    sendMessage,
    getAllMessage,
    getAllMessageWithQuery,
    disconnect,
    endIQ,
    connect,
    getRoster,
    contacts,
    setConnect,
  };
};

export default StropheProvider;